(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9717],{

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 59987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Timers = (param)=>{
    let { delayResend ="300" , setDelayTrigger , delayTrigger , setResendEnable , staticTexts  } = param;
    const [delay, setDelay] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(+delayResend);
    const minutes = Math.floor(delay / 60);
    const seconds = Math.floor(delay % 60);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (delayTrigger) {
            setDelay(+delayResend);
            setDelayTrigger(false);
        }
    }, [
        delayTrigger
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const timer = setInterval(()=>{
            setDelay(delay - 1);
        }, 1000);
        if (delay === 0) {
            clearInterval(timer);
            setDelayTrigger(false);
            setResendEnable(true);
        }
        return ()=>{
            clearInterval(timer);
        };
    }, [
        delay
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "expireotp",
                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.otpexpire
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "auth-otp-modal__timer",
                children: [
                    minutes >= 10 ? minutes : "0".concat(minutes),
                    ":",
                    seconds >= 10 ? seconds : "0".concat(seconds)
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Timers);


/***/ }),

/***/ 83507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const TimersNew = (param)=>{
    let { delayResend ="900" , setDelayTriggerTry , delayTriggerTry , setReTryEnable , setNumberOfTries , staticTexts , mobileData , tryAgaininmin =false , setExceededAttempts , setResendEnable , setVerifyDisable , resetError , setDelayTrigger  } = param;
    const [delay, setDelay] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(+delayResend);
    const [intervalId, setIntervalId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (delayTriggerTry) {
            setDelay(+delayResend);
            setDelayTriggerTry(false);
        }
    }, [
        delayTriggerTry
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const timer = setInterval(()=>{
            setDelay(delay - 1);
            localStorage.setItem("checkoutNumber_" + (mobileData === null || mobileData === void 0 ? void 0 : mobileData.value), delay - 1);
        }, 1000);
        if (delay === 0) {
            clearInterval(timer);
            setDelayTriggerTry(false);
            setReTryEnable(false);
            setNumberOfTries(3);
            setExceededAttempts(false);
            setResendEnable(true);
            setVerifyDisable(false);
            resetError();
            setDelayTrigger(false);
            localStorage.removeItem("checkoutNumber_" + (mobileData === null || mobileData === void 0 ? void 0 : mobileData.value));
        }
        return ()=>{
            clearInterval(timer);
        };
    }, [
        delay
    ]);
    // useEffect(() => {
    //   const timer = setInterval(() => {
    //     setDelay(delay - 1)
    //     localStorage.setItem("checkoutNumber_" + mobileData?.value, delay - 1)
    //   }, 1000)
    //   if (delay === 0) {
    //     clearInterval(timer)
    //     setDelayTriggerTry(false)
    //     setReTryEnable(false)
    //     setNumberOfTries(3)
    //     setExceededAttempts(false)
    //     setResendEnable(true)
    //     setVerifyDisable(false)
    //     resetError()
    //     setDelayTrigger(false)
    //     localStorage.removeItem("checkoutNumber_" + mobileData?.value)
    //   }
    //   return () => {
    //     clearInterval(timer)
    //   }
    // }, [delay])
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "auth-otp-modal__timer",
            children: !tryAgaininmin ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.tryAgain : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.tryagainmin
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimersNew);


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52786);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34326);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21531);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    var ref1, ref2;
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const errorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    var _type;
    const [type, setType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_type = props.type) !== null && _type !== void 0 ? _type : "text");
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [matchedItem, setMatchedItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedListItem, setListItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { showError , errorMessage , id , linkText ="" , showLink =false , onClickLink =()=>{} , hideLabelOnFocus =false  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (toggle) setType("text");
        else setType("password");
    }, [
        toggle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            inputRef.current.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showError && errorMessage) {
            // errorRef.current.focus()
            if (ref) {
                ref.current.focus();
            } else {
                inputRef.current.focus();
            }
        }
    }, [
        showError,
        errorMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const keyPressEvent = (e)=>{
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            if (e.keyCode === KEYCODE.TAB && showList) {
                setShowList(false);
            }
        };
        document.addEventListener("keydown", keyPressEvent);
        return ()=>{
            document.removeEventListener("keydown", keyPressEvent);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        if (((ref = props.value) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = props.suggestions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            setShowList(true);
            selectListItem();
            setActivedescendant();
        } else setShowList(false);
    }, [
        props.value,
        props.suggestions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) setActivedescendant();
    }, [
        showList
    ]);
    const selectListItem = ()=>{
        const listItems = [
            ...props.suggestions
        ];
        const firstMatchedItem = listItems.find((item)=>{
            if (item === null || item === void 0 ? void 0 : item.includes(props.value)) return item;
        });
        setMatchedItem(firstMatchedItem);
    };
    var _id;
    const setActivedescendant = ()=>{
        var ref;
        return setListItem((_id = (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].id) !== null && _id !== void 0 ? _id : "");
    };
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("input-field__border", props.disabled ? "--disabled" : null, props.showError ? "--with-error" : null, focus ? "--focused" : null);
    const i18n = {
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        resultsText: t("kf.input.aria.resultsText")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("click", function(e) {
            var ref;
            if (showList && !((ref = document.getElementById("".concat(props.id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setShowList(false);
        });
    }, []);
    const handleClick = ()=>{
        var ref;
        return (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleKeyDown = (e)=>{
        if (showList) {
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            const ele = [
                ...document.getElementById("".concat(props.id, "-list")).childNodes
            ];
            let index = 0;
            const selectedItem = ele.find((item, i)=>{
                if (item.id === selectedListItem) {
                    index = i;
                    return item;
                }
            });
            switch(e.keyCode){
                case KEYCODE.ESC:
                    setShowList(false);
                    break;
                case KEYCODE.UP:
                    e.preventDefault();
                    if (index > 0) ele.forEach((item, i)=>{
                        if (i === index - 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.smoothScroll)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.DOWN:
                    e.preventDefault();
                    if (index < ele.length - 1) ele.forEach((item, i)=>{
                        if (i === index + 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.smoothScroll)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.SPACE:
                    break;
                case KEYCODE.ENTER:
                    selectedItem.click();
                    break;
                default:
                    break;
            }
        }
    };
    var _ariaRequried;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputFieldWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " input-field ".concat(props.customClass ? props.customClass : ""),
            id: "".concat(props.id, "-wrapper"),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: inputClasses,
                    children: [
                        props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__prefix",
                            children: props.prefix
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "input-field__value",
                            onKeyDown: (e)=>handleKeyDown(e),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    ref: ref !== null && ref !== void 0 ? ref : inputRef,
                                    id: props.id,
                                    type: props.type === "password" ? type : props.type,
                                    value: props.value,
                                    name: props.name,
                                    autoComplete: props.autoComplete ? "on" : "off",
                                    maxLength: props.maxLength,
                                    disabled: props.disabled,
                                    placeholder: props.label.replace(/\*/g, ""),
                                    onChange: props.onChange,
                                    onKeyUp: props.onKeyUp,
                                    onKeyDown: props.onKeyDown,
                                    onKeyPress: handleKeyDown,
                                    onFocus: (e)=>{
                                        setFocus(true);
                                        props.onFocus && props.onFocus(e);
                                    },
                                    onBlur: (e)=>{
                                        setFocus(false);
                                        props.onBlur && props.onBlur(e);
                                    },
                                    max: props.max,
                                    min: props.min,
                                    autoFocus: props.autoFocus,
                                    "aria-required": ((_ariaRequried = props.ariaRequried) !== null && _ariaRequried !== void 0 ? _ariaRequried : props.label.indexOf("*") > 0) ? true : false,
                                    "aria-activedescendant": props.autoComplete ? selectedListItem : "undefined",
                                    "aria-readonly": props.readOnly ? "true" : "false",
                                    "aria-owns": "".concat(props.id, "-list"),
                                    // aria-expanded={props.autoComplete ? showList : "undefined"}
                                    "aria-haspopup": props.autoComplete ? "listbox" : "false",
                                    "data-testid": "input",
                                    pattern: props.pattern,
                                    onPaste: props.onPaste
                                }),
                                !hideLabelOnFocus ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: props.id,
                                    "aria-hidden": "true",
                                    children: props.label
                                }) : !focus && !(props === null || props === void 0 ? void 0 : (ref1 = props.value) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: props.id,
                                    "aria-hidden": "true",
                                    children: props.label
                                })
                            ]
                        }),
                        props.type === "password" && ((ref2 = props.value) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                tabIndex: "0",
                                "aria-label": toggle ? "".concat(i18n.hide, " ").concat(props.label) : "".concat(i18n.show, " ").concat(props.label),
                                role: "button",
                                onClick: ()=>setToggle(!toggle),
                                className: "input-field__toggle",
                                children: toggle ? i18n.hide : i18n.show
                            })
                        }),
                        props.suffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: props.suffix
                        })
                    ]
                }),
                showList && props.suggestions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    id: "".concat(props.id, "-list"),
                    className: "input-field__suggestions",
                    role: "listbox",
                    "aria-label": i18n.resultsText,
                    children: props.suggestions.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            id: "suggestion-list-item-".concat(i),
                            className: "input-field__list-item ".concat(matchedItem === item ? "--hover" : ""),
                            "aria-selected": selectedListItem === item ? "true" : "false",
                            role: "option",
                            onClick: ()=>props.onSelect(item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "input-field__list-value",
                                children: item
                            })
                        }, i))
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    ref: errorRef,
                    "aria-live": "polite",
                    role: "alert",
                    id: "".concat(id, "-error"),
                    className: "input-field__error-message",
                    children: [
                        errorMessage,
                        showLink && linkText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "input-field__error-link",
                            onClick: onClickLink,
                            children: linkText
                        })
                    ]
                })
            ]
        })
    });
});
Input.displayName = "Input";
Input.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 95357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./src/components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
;// CONCATENATED MODULE: ./public/icons/modal-close.svg
/* harmony default export */ var modal_close = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});
// EXTERNAL MODULE: ./components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(43106);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false , isConfirm =false , closeOnOutsideClick =false , widthClass  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper.preventBodyScroll)(false);
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (!isConfirm && (width < 577 || lib/* isIOS */.gn && width < 992)) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper.setFocus)(window.keyFocusCallBack);
            }
        }
        (0,helper.preventBodyScroll)(showModal);
        window.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            window.removeEventListener("mousedown", handleClickOutside);
            (0,helper.preventBodyScroll)(false);
        };
    }, [
        showModal
    ]);
    const handleClickOutside = (e)=>{
        if (closeOnOutsideClick && modalWindow.current && !modalWindow.current.contains(e.target)) {
            triggerModalClose();
        }
    };
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : "common-OTP-flow"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close === null || modal_close === void 0 ? void 0 : modal_close.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body ".concat(widthClass ? widthClass : ""),
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 11859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7154);
/* eslint-disable require-jsdoc */ 

const useWindowResize = function() {
    let isMobile = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
         true ? window.innerWidth : 0,
         true ? window.innerHeight : 0
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (isSsr) {
            return;
        }
        setSize([
            window.innerWidth,
            window.innerHeight
        ]);
        function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        }
        if (!isSsr) {
            window.addEventListener("resize", updateSize);
            updateSize();
        }
        return ()=>window.removeEventListener("resize", updateSize);
    }, [
        isSsr
    ]);
    return [
        ...size,
        "object" === undefined
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowResize);


/***/ }),

/***/ 20234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52786);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25935);



const useAuthModali18n = (props)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    var ref, ref1;
    const i18n = {
        createAccountMobileNumber: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountMobileNumber)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Mobile Number*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountMobileNumber).replaceAll("&amp;nbsp;", " ")),
        createAccountFormIAgreeText: (ref = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountFormIAgreeText).replaceAll("&amp;nbsp;", " "))) !== null && ref !== void 0 ? ref : "",
        phoneExists: t("kf.auth.label.createaccount.error.phoneexits", "An account already exists with this phone number. Please sign in to access your account."),
        signin: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.signIn)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Sign In") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.signIn).replaceAll("&amp;nbsp;", " ")),
        signinWithOTP: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginMainTitle)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.signinWithOTP", "sign in with an otp") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginMainTitle).replaceAll("&amp;nbsp;", " ")),
        createAccount: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccount)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Create Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccount).replaceAll("&amp;nbsp;", " ")),
        enterMobileNumber: t("kf.login.enterMobileNumber", "Mobile Number*"),
        getOTP: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginCtaLabel)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.getOTP", "Get OTP") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginCtaLabel).replaceAll("&amp;nbsp;", " ")),
        policyText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginPrivacyPolicyText).replaceAll("&amp;nbsp;", " ")),
        label: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowScreen2Description)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.label", "A six-digit OTP has been sent to") : props === null || props === void 0 ? void 0 : props.otpFlowScreen2Description.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, ""),
        backToSignIn: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginBackButtonText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.backToSignIn", "Back To Sign In") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginBackButtonText).replaceAll("&amp;nbsp;", " ")),
        verifySignIn: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginScreen2ctaLabel)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.verify", "Verify") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginScreen2ctaLabel).replaceAll("&amp;nbsp;", " ")),
        otpNotReceived: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginResendOtpText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.otpNotReceived", "Your OTP has expired") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginResendOtpText).replaceAll("&amp;nbsp;", " ")),
        resendOTP: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginResendOtpLabel)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.resendOTP", "Resend OTP") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginResendOtpLabel).replaceAll("&amp;nbsp;", " ")),
        tryAgain: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginExceededAttemptText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.tryAgain", "Please try again in 15 minutes") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginExceededAttemptText).replaceAll("&amp;nbsp;", " ")),
        exitConfirmation: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginConfirmationText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.exitConfirmation", "Are you sure you want to leave this section?") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginConfirmationText).replaceAll("&amp;nbsp;", " ")),
        yes: t("kf.contactus.label.yes", "Yes"),
        no: t("kf.contactus.label.no", "No"),
        tryagainmin: t("kf.login.tryAgainmin", "Please try again in 5 minutes"),
        errorPhoneNumber: t("kf.login.errorPhoneNumber", "Please enter a valid mobile number"),
        viewFavoritesLogin: t("kf.login.viewFavoritesLogin", "Please sign-in to manage your favorites"),
        signinDescription: t("kf.signin.desc", "Please ensure you provide a valid mobile number."),
        invalidOTP: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginOtpErrorMessage)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.invalidOTP", "OTP is invalid or no longer active") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.loginOtpErrorMessage).replaceAll("&amp;nbsp;", " ")),
        mobileDescription: t("kf.auth.label.createaccount.mobileDescription", "Enter the six-digit code sent to "),
        resend: t("kf.auth.label.createaccount.resend", "Resend OTP"),
        otpexpire: t("kf.signin.otpexpire", "Your OTP will expire in "),
        receiveOTP: t("kf.auth.label.createaccount.receiveOTP", "Your OTP has expired"),
        getOTP: t("kf.auth.label.createaccount.getOTP", "Get OTP"),
        verify: t("kf.auth.label.createaccount.verify", "Verify"),
        errorOTP: t("kf.auth.label.createaccount.verifyOTP", "OTP is not valid. Please enter a valid OTP to continue."),
        exceedlimit: t("kf.auth.label.createaccount.exceedlimit", "You have exceeded limit for OTP attempts."),
        changeNumber: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowScreen2MobilePlaceholder)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.login.changeNumber", "Edit number") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowScreen2MobilePlaceholder).replaceAll("&amp;nbsp;", " ")),
        backToCreate: t("kf.auth.label.createaccount.backToCreateAccount", "Back to Create Account"),
        createTitle: t("kf.auth.label.createaccount.title", "Create an account with your mobile number"),
        termsCondition: t("kf.auth.label.createaccount.terms"),
        signin: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.signIn)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Sign In") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.signIn).replaceAll("&amp;nbsp;", " ")),
        createAccount: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccount)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Create Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccount).replaceAll("&amp;nbsp;", " ")),
        createYourAccount: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountFormTitle)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.createYourAccount", "Create Your Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountFormTitle).replaceAll("&amp;nbsp;", " ")),
        email: t("kf.auth.label.email", "Email"),
        password: t("kf.auth.label.password", "Password"),
        homeowneremail: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeowneremail)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.emailAddress", "Email Address*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeowneremail).replaceAll("&amp;nbsp;", " ")),
        homeownerpassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerpassword)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.homeownerpassword", "Password*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerpassword).replaceAll("&amp;nbsp;", " ")),
        forgotPassword: t("kf.auth.label.forgotPassword", "Forgot password?"),
        keepMeLoggedIn: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.keepMeLoggedIn)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.keepMeLoggedIn", "Keep me logged in") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.keepMeLoggedIn).replaceAll("&amp;nbsp;", " ")),
        loginWithFacebook: t("kf.auth.label.loginWithFacebook", "Continue with Facebook"),
        loginWithGoogle: t("kf.auth.label.loginWithGoogle", "Continue with Google"),
        loginWithApple: t("kf.auth.label.loginWithApple", "Continue with Apple"),
        createAccountDesc: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountDesc)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.createAccountDesc", "Creating your Kohler account provides benefits across all of our brands:") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountDesc).replaceAll("&amp;nbsp;", " ")),
        subjectAccessReq: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.subjectAccessReq)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.subjectAccessReq", "Subject Access Request") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.subjectAccessReq).replaceAll("&amp;nbsp;", " ")),
        homeOwnerAccount: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeOwnerAccount)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.homeOwnerAccount", "Homeowner Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeOwnerAccount).replaceAll("&amp;nbsp;", " ")),
        homeOwnerAccountDesc: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeOwnerAccountDesc)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.homeOwnerAccountDesc", "For individual customers planning and purchasing for their home.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeOwnerAccountDesc).replaceAll("&amp;nbsp;", " ")),
        professionalAccount: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalAccount)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.professionalAccount", "Professional Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalAccount).replaceAll("&amp;nbsp;", " ")),
        professionalAccountDesc: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalAccountDesc)) ? t("kf.auth.label.professionalAccountDesc", "For residential and commercial construction industry and business needs.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalAccountDesc).replaceAll("&amp;nbsp;", " ")),
        privacyPolicy: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.privacypolicy)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.privacyPolicy", "Privacy Policy") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.privacypolicy).replaceAll("&amp;nbsp;", " ")),
        termsOfService: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.termsofservice)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.termsOfService", "Terms of Service") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.termsofservice).replaceAll("&amp;nbsp;", " ")),
        personalRecommendations: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.recommendations)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.personalRecommendations", "Personalized recommendations") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.recommendations).replaceAll("&amp;nbsp;", " ")),
        accessToFeatures: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.projectplanningfeatures)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.accessToFeatures", "Access to project planning features") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.projectplanningfeatures).replaceAll("&amp;nbsp;", " ")),
        savePaymentsAndAddress: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.preferences)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.savePaymentsAndAddress", "Save preferences") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.preferences).replaceAll("&amp;nbsp;", " ")),
        quickCheckout: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.checkoutfaster)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.quickCheckout", "Check out faster") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.checkoutfaster).replaceAll("&amp;nbsp;", " ")),
        easyOrderTracking: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.easilytrackorders)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.easyOrderTracking", "Easily track orders") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.easilytrackorders).replaceAll("&amp;nbsp;", " ")),
        requiredFields: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.fieldnamerequired)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.requiredFields", "Fields marked with * are required.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.fieldnamerequired).replaceAll("&amp;nbsp;", " ")),
        validEmail: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeowneremailError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.validEmail", "Please enter a valid email address.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeowneremailError).replaceAll("&amp;nbsp;", " ")),
        professionalaccemailError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccemailError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.validEmail", "Please enter a valid email address.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccemailError).replaceAll("&amp;nbsp;", " ")),
        validPassword: t("kf.auth.error.validPassword", "Please enter a valid password."),
        invalidEmailOrPassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.invalidEmailOrPassword)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.invalidEmailOrPassword", "Sorry, the email or password you've provided does not match our records. Please try again.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.invalidEmailOrPassword).replaceAll("&amp;nbsp;", " ")),
        lockedOut: t("kf.auth.error.lockedOut", "You have exceeded the permitted number of failed login attempts. To access your account, please reset your password."),
        contactSupport: t("kf.auth.error.contactSupport", "contact support."),
        mobileLabel: t("kf.auth.label.createaccount.mobileNumber", "Mobile Number*"),
        mobilenumber: t("kf.auth.label.createaccount.mobilenumber", "Mobile Number*"),
        fnameError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerfirstnameError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.fnameErrorNew", "Your first name is required.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerfirstnameError).replaceAll("&amp;nbsp;", " ")),
        professionalaccfirstnameError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccfirstnameError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.fnameErrorNew", "Your first name is required.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccfirstnameError).replaceAll("&amp;nbsp;", " ")),
        lnameError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerLastNameError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.lnameError", "Your last name is required.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerLastNameError).replaceAll("&amp;nbsp;", " ")),
        professionalacclastnameError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalacclastnameError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.lnameError", "Your last name is required.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalacclastnameError).replaceAll("&amp;nbsp;", " ")),
        passwordError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerpasswordError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.passwordError", "Your password must contain at least 10 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol (!@#$%^&*).  Password should not contain username, common words, first or last name, email id domain name or any of your last 4 passwords.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerpasswordError).replaceAll("&amp;nbsp;", " ")),
        passwordMatchError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.passwordMismatcherror)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.passwordMatchError", "New & Re-Enter passwords do not match.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.passwordMismatcherror).replaceAll("&amp;nbsp;", " ")),
        zipcodeError: t("kf.auth.error.zipcodeError", "Please provide your business zipcode."),
        validZipcode: t("kf.auth.error.validZipcode", "Please enter a valid zipcode."),
        businessTypeError: t("kf.auth.error.businessTypeError", "Please provide your business type."),
        subTypeError: t("kf.auth.error.subTypeError", "Please provide your account sub-type."),
        homeownerfirstname: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerfirstname)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.firstName", "First Name*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerfirstname).replaceAll("&amp;nbsp;", " ")),
        homeownerLastName: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerLastName)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.lastName", "Last Name*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerLastName).replaceAll("&amp;nbsp;", " ")),
        zipcode: t("kf.auth.label.zipcode", "Business ZIP Code"),
        companyName: t("kf.auth.label.companyName", "Company Name*"),
        companyNameError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.companyNameError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.companyNameError", "Please enter your company name.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.companyNameError).replaceAll("&amp;nbsp;", " ")),
        companyNameAlphanumericError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.companyNameAlphanumericError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.companyNameAlphanumericError", "Please enter only alphanumeric and safe characters.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.companyNameAlphanumericError).replaceAll("&amp;nbsp;", " ")),
        emailAddress: t("kf.auth.label.emailAddress", "Email Address*"),
        passwordRequirements: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.passwordRequirements)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.passwordRequirements", "Password Requirements") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.passwordRequirements).replaceAll("&amp;nbsp;", " ")),
        primaryBusinessType: t("kf.auth.label.primaryBusinessType", "Primary Business Type"),
        accountSubType: t("kf.auth.label.accountSubType", "Account Sub-Type"),
        signupForNewsletter: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.newsletterSignUp)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.signupForNewsletter", "Sign me up for the e-newsletter") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.newsletterSignUp).replaceAll("&amp;nbsp;", " ")),
        alreadyHaveAccount: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.alreadyHaveAnAccount)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.alreadyHaveAccount", "Already have an account? ") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.alreadyHaveAnAccount).replaceAll("&amp;nbsp;", " ")),
        pwMustInclude: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.authorablepassworddialog)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.pwMustInclude", "Password must include:") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.authorablepassworddialog).replaceAll("&amp;nbsp;", " ")),
        showDialog: false,
        welcomeTo: (ref1 = props === null || props === void 0 ? void 0 : props.hi) !== null && ref1 !== void 0 ? ref1 : t("kf.auth.label.welcomeTo", "Welcome to Kohler"),
        welcomeMessage: props === null || props === void 0 ? void 0 : props.accountSuccessDesc,
        checkoutWelcomeMessage: t("kf.auth.label.welcomeMessage", "Get the most out of your new Kohler account by completing your profile."),
        finishProfile: t("kf.auth.label.finishProfile", "Finish my profile"),
        accountSuccessCTA: props === null || props === void 0 ? void 0 : props.accountSuccessCTA,
        accountSuccessLink: props === null || props === void 0 ? void 0 : props.accountSuccessLink,
        continueShopping: t("kf.auth.label.continueShopping", "Continue Shopping"),
        sendEmail: t("kf.auth.label.sendEmail", "Send Email"),
        resendEmail: t("kf.auth.label.resendEmail", "Resend Email"),
        continueShipping: t("kf.checkout.label.continuetoshipping", "Continue to Shipping"),
        otpDescription: t("kf.checkout.label.customerInstruction", 'Mobile number verification required via one-time password. Enter a valid mobile number and then click "Get OTP" to get a six-digit code sent to your mobile device.'),
        backToSignin: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.backToSignIn)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.backToSignin", "Back to Sign In") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.backToSignIn).replaceAll("&amp;nbsp;", " ")),
        resetPassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordTitle)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.resetPassword", "Reset Your Password") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordTitle).replaceAll("&amp;nbsp;", " ")),
        mailSent: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordStep2Title)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.mailSent", "Your email has been sent.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordStep2Title).replaceAll("&amp;nbsp;", " ")),
        checkEmail: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordStep2Desc)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.checkEmail", "Please check your email for instructions to reset your password.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordStep2Desc).replaceAll("&amp;nbsp;", " ")),
        forgotPasswordDesc: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordDesc)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.forgotPasswordDesc", "Enter the email address associated with your account, and we will send you an email with a link to reset your password.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.resetPasswordDesc).replaceAll("&amp;nbsp;", " ")),
        emailAlreadyExists: t("kf.auth.error.emailAlreadyExists", "An account already exists for this email. Please sign in."),
        submit: t("kf.auth.label.submit", "Submit"),
        close: t("kf.auth.label.close", "Close"),
        signinAria: t("kf.auth.label.signinAria", "Sign in. Tap or click here to sign in."),
        createAccountAria: t("kf.auth.label.createAccountAria", "Create an account. Tap or click here to create an account."),
        homeOwnerAria: t("kf.auth.label.homeOwnerAria", "Home-owner create account"),
        proAccountAria: t("kf.auth.label.proAccountAria", "Professional create account"),
        authModalAria: t("kf.auth.label.authModalAria", "You are on Sign-in / Create an account modal window."),
        signupModalAria: t("kf.auth.label.signupModalAria", "You are on Create Account modal window."),
        forgotPwdModalAria: t("kf.auth.label.forgotPwdModalAria", "You are on forgot password modal window."),
        welcomeAria: t("kf.auth.label.welcomeAria", "Account created succesfully"),
        pwdError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerpasswordError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.provide.pwdError", "Please provide the Password.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerpasswordError).replaceAll("&amp;nbsp;", " ")),
        reEnterPwdError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerreenterpasswordError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.provide.reEnterPwdError", "Please provide the Re-enter password.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerreenterpasswordError).replaceAll("&amp;nbsp;", " ")),
        professionalaccpasswordError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccpasswordError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.provide.pwdError", "Please provide the Password.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccpasswordError).replaceAll("&amp;nbsp;", " ")),
        professionalaccreenterpasswordError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccreenterpasswordError)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.provide.pwdError", "Please provide the Password.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccreenterpasswordError).replaceAll("&amp;nbsp;", " ")),
        signinOrSignup: t("kf.cart.label.signinOrSignup", "Sign In / Create Account"),
        generalAuthenticationError: t("kf.auth.error.generalAuthenticationError", "We have technical difficulties at this time, please try again later."),
        homeOwnerAccountCTA: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeOwnerAccountCTA)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Create Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeOwnerAccountCTA).replaceAll("&amp;nbsp;", " ")),
        professionalAccountCTA: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalAccountCTA)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("Create Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalAccountCTA).replaceAll("&amp;nbsp;", " ")),
        proUserWelcomeMsg: t("kf.auth.label.proUserWelcomeMessage", "You are being redirected to an external website."),
        proUserSuccessCTA: t("kf.auth.label.proUserSuccessCTA", "Continue to Trade Programs"),
        professionalaccfirstname: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccfirstname)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.firstName", "First Name*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccfirstname).replaceAll("&amp;nbsp;", " ")),
        professionalacclastname: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalacclastname)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.lastName", "Last Name*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalacclastname).replaceAll("&amp;nbsp;", " ")),
        professionalaccemail: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccemail)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.emailAddress", "Email Address*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccemail).replaceAll("&amp;nbsp;", " ")),
        signinhyperlink: "".concat(props === null || props === void 0 ? void 0 : props.signinhyperlink) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? "" : "".concat(props === null || props === void 0 ? void 0 : props.signinhyperlink),
        homeownerreenterpassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerreenterpassword)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.reEnterPassword", "Re-Enter Password*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.homeownerreenterpassword).replaceAll("&amp;nbsp;", " ")),
        professionalaccpassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccpassword)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.homeownerpassword", "Password*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccpassword).replaceAll("&amp;nbsp;", " ")),
        professionalaccreenterpassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccreenterpassword)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.label.reEnterPassword", "Re-Enter Password*") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.professionalaccreenterpassword).replaceAll("&amp;nbsp;", " ")),
        signInValidEmail: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.invalidEmail)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.auth.error.validEmail", "Please enter a valid email address.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.invalidEmail).replaceAll("&amp;nbsp;", " ")),
        regexForSiginPassword: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.regexForPassword).replaceAll("&amp;nbsp;", " ")),
        maxStock: (quantity)=>"Only ".concat(quantity, " items available in stock. Please update the quantity to proceed."),
        existEmailAddress: (mobileNo)=>t("kf.checkout.label.existEmail", {
                mobileNo
            }, "Sorry this email address is already in use. Please provide the correct mobile number XXXXX XX".concat(mobileNo, ' to use this email address. Alternatively, you can create a new account by using a different email address."),\n    errorMobileNumber: t("kf.customerSupport.error.validMobileNumber')),
        confirmationmodal: t("kf.checkout.label.confirmationmodal"),
        signinPasswordFormatError: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.passwordFormatError).replaceAll("&amp;nbsp;", " ")),
        createAccountPrivacyPolicy: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.createAccountScreen2PrivacyPoilcy).replaceAll("&amp;nbsp;", " ")),
        verifyMobileNumber: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowDescription)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.customerSupport.message.verifyPhone", "Please verify your mobile number") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowDescription).replaceAll("&amp;nbsp;", " ")),
        mobileVerification: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowMainTitle)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFLow.mobileVerification", "Mobile Number Verification") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpFlowMainTitle).replaceAll("&amp;nbsp;", " ")),
        verificationTitle: t("kf.auth.label.verificationTitle", "Mobile number verification"),
        otpTitle: t("kf.otpFlow.otpTitle", "Please enter the OTP to verify your mobile number"),
        changeMobileTitle: t("kf.otpFlow.changeMobileTitle", "Please enter a valid mobile number"),
        changeMobileDescription: t("kf.login.changeMobileDescription", "A six-digit OTP will then be sent to your device."),
        verificationDescription: "kf.auth.label.verificationDescription",
        signupTtile: t("kf.auth.label.signupTitle", "CUSTOMER Information"),
        updateNumber: t("kf.otpFlow.updateNumber", "Change Mobile Number"),
        numberAlreadyExists: t("kf.otpFlow.numberAlreadyExists", "An account already exists with this number."),
        numberNotRegistered: t("kf.auth.label.numberNotRegistered", "Mobile Number not registered. Please try"),
        mobileNumber: t("kf.otpFlow.mobileNumber", "Mobile Number*"),
        close: t("kf.findStoreUtilNav.label.closeAlt", "Close"),
        numberNotRegistered: t("kf.auth.label.numberNotRegistered", "Mobile Number not registered. Please try"),
        creatingAnAccount: t("kf.auth.label.creatingAnAccount", "creating an Account"),
        otpSentDescription: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.sixDigitOtpText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.otpSentDescription", "A six-digit OTP has been sent to") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.sixDigitOtpText).replaceAll("&amp;nbsp;", " ")),
        changeMobileNumberText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.changeMobileNumberText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.changeMobileNumberText", "Change mobile number") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.changeMobileNumberText).replaceAll("&amp;nbsp;", " ")),
        otpExpirationTime: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpExpireDurationText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.otpExpirationTime", "Your OTP will expire in") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpExpireDurationText).replaceAll("&amp;nbsp;", " ")),
        otpExpirationText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpExpirationText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.otpExpirationText", "Your OTP has expired") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpExpirationText).replaceAll("&amp;nbsp;", " ")),
        otpInvalidText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpInvalidText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.otpInvalidText", "OTP is not valid. Please enter a valid OTP to continue.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpInvalidText).replaceAll("&amp;nbsp;", " ")),
        limitExceededText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.limitExceededText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.limitExceededText", "You have exceeded limit for OTP attempts.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.limitExceededText).replaceAll("&amp;nbsp;", " ")),
        otpCantSendText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpCantSendText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.otpCantSendText", "A six digit OTP can not be sent to") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.otpCantSendText).replaceAll("&amp;nbsp;", " ")),
        tryAgainText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.tryAgainText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.tryAgainText", "at this time. Please try again later.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.tryAgainText).replaceAll("&amp;nbsp;", " ")),
        mobileNumberChangedSuccessText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.mobileNumberChangedSuccessText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.mobileNumberChangedSuccessText", "You have successfully changed your mobile number.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.mobileNumberChangedSuccessText).replaceAll("&amp;nbsp;", " ")),
        profileCompletionText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.profileCompletionText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.profileCompletionText", "Get the most ouf of your new Kohler account by completing your profile.") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.profileCompletionText).replaceAll("&amp;nbsp;", " ")),
        viewMyAccountText: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.viewMyAccountText)) === _constants__WEBPACK_IMPORTED_MODULE_1__["default"].UNDEFINED ? t("kf.otpFlow.viewMyAccountText", "View my Account") : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(props === null || props === void 0 ? void 0 : props.viewMyAccountText).replaceAll("&amp;nbsp;", " ")),
        noEmailError: t("kf.contactus.error.noEmailError", "Please provide your email address"),
        activateAccountTitle: t("kf.otpFlow.activateAccountTitle", "Activate your account"),
        activateAccountDesc: t("kf.otpFlow.activateAccountDesc", "Complete the following OTP to link your KOHLER account. You'll then recive another OTP to sign in. A six-digit OTP has been sent to"),
        activateAccountCta: t("kf.otpFlow.activateAccountCta", "Activate My Account")
    };
    if (i18n.pwMustInclude === t("kf.auth.label.pwMustInclude", "Password must include:")) {
        i18n.showDialog = true;
        i18n.characterCount = t("kf.auth.label.characterCount", "10 or more characters");
        i18n.uppercaseLetter = t("kf.auth.label.uppercaseLetter", "1 Uppercase letter");
        i18n.lowercaseLetter = t("kf.auth.label.lowercaseLetter", "1 Lowercase letter");
        i18n.symbolValidation = t("kf.auth.label.symbolValidation", "1 Symbol: (ex. $#!@*&)");
        i18n.numberValidation = t("kf.auth.label.numberValidation", "1 Number");
    }
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModali18n);


/***/ }),

/***/ 82476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77529);
/* harmony import */ var _components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4__);






const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { label , size , type , flexible , disabled , onClick , customClass , to , target , className , loading , role , tag , tabIndex =0 , ariaLabel , parentClass , useDefaultClass , testid ="" , ...remainingProps } = props;
    const buttonClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("kf-react-button", "button", className ? className : null, size ? size : "large", type ? type : "primary", flexible ? "flexible" : null, disabled ? "disabled" : null, customClass ? customClass : null, loading ? "loading" : null);
    const ButtonTag = tag === "button" || role === "button" ? "button" : tag === "anchor" ? "a" : (next_link__WEBPACK_IMPORTED_MODULE_3___default());
    const buttonFullClass = useDefaultClass ? (_components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonWrapper) : (_components_core_Button_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonWrapper) + " " + buttonClass + " " + (parentClass || "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: buttonFullClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonTag, {
            ...remainingProps,
            className: buttonClass,
            onClick: onClick,
            href: to !== null && to !== void 0 ? to : "",
            target: target,
            role: role !== null && role !== void 0 ? role : "",
            tabIndex: tabIndex,
            "aria-label": ariaLabel,
            "aria-disabled": disabled,
            "data-testid": "button".concat(testid ? "-".concat(testid) : ""),
            ref: ref,
            children: [
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "loader"
                }),
                label
            ]
        })
    });
});
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["Z"] = (Button);
Button.propTypes = {
    label: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    flexible: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    customClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    parentClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};


/***/ }),

/***/ 34846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/core/Checkbox/index.module.scss
var index_module = __webpack_require__(93468);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/checkbox-tick.svg
/* harmony default export */ var checkbox_tick = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./src/components/core/Checkbox/Checkbox.jsx







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        e.target.checked = !props.checked;
        if (e.keyCode === 32 || e.keyCode === 13) props.onChange(e);
    };
    var _tabIndex, _role, _checkBoxAria;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).checkboxWrapper).concat(inline ? " ".concat((index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            htmlFor: props.id,
            "aria-checked": props.checked,
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "checkbox",
            "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            onKeyDown: handleCheck,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick.src,
                            alt: "Checkbox"
                        })
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
Checkbox.protoTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    tabIndex: (prop_types_default()).number,
    role: (prop_types_default()).string,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};


/***/ }),

/***/ 55754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DB": function() { return /* binding */ leadCreation; },
/* harmony export */   "HQ": function() { return /* binding */ getKECAppointments; },
/* harmony export */   "H_": function() { return /* binding */ activateUserFactor; },
/* harmony export */   "a$": function() { return /* binding */ registerUser; },
/* harmony export */   "d_": function() { return /* binding */ getPlacementName; },
/* harmony export */   "gU": function() { return /* binding */ checkNumberExists; },
/* harmony export */   "go": function() { return /* binding */ submitLeadGeneration; },
/* harmony export */   "kM": function() { return /* binding */ cleverTapSubscribe; },
/* harmony export */   "vn": function() { return /* binding */ submitProductEnquiry; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11310);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34326);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45094);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88751);






const submitProductEnquiry = async (payload)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .submitDealershipUrl */ .Bp), payload);
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const activateUserFactor = async (payload)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .activateUserFactorUrl */ .tR), payload);
            resolve(response);
        } catch (error) {
            var ref, ref1, ref2;
            if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 403 || (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 429 || (error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 404) resolve(error === null || error === void 0 ? void 0 : error.response);
            else reject(error);
        }
    });
};
const checkNumberExists = async (mobileNumber)=>{
    let numberExists = false;
    let factorId, userId;
    await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .checkDuplicacy */ .tH)(mobileNumber)).then((res)=>{
        var ref, ref1;
        if ((res === null || res === void 0 ? void 0 : (ref = res.payload) === null || ref === void 0 ? void 0 : ref.statusCode) == 400 && (res === null || res === void 0 ? void 0 : (ref1 = res.payload) === null || ref1 === void 0 ? void 0 : ref1.message) === "USER_EXIST") {
            localStorage.setItem("numberAlreadyExists", mobileNumber);
            numberExists = true;
        } else {
            var ref2, ref3, ref4, ref5, ref6, ref7;
            localStorage.removeItem("numberAlreadyExists");
            numberExists = false;
            factorId = res === null || res === void 0 ? void 0 : (ref2 = res.payload) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.userFactor) === null || ref4 === void 0 ? void 0 : ref4.id;
            userId = res === null || res === void 0 ? void 0 : (ref5 = res.payload) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.user) === null || ref7 === void 0 ? void 0 : ref7.id;
        }
    });
    return {
        numberExists,
        factorId,
        userId
    };
};
const submitLeadGeneration = async (param)=>{
    let { payload , isKECForm =false  } = param;
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    const url = isKECForm ? "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .submitLeadGenerationUrl */ .uF, "?storeLeads=KEC_").concat(payload.city) : "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .submitLeadGenerationUrl */ .uF, "?festival=diwali");
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(url), payload);
            resolve(content);
        } catch (error) {
            resolve(error);
        }
    });
};
const leadCreation = async (param)=>{
    let { payload , authorData  } = param;
    const url = authorData.omniChannelKECFormFlag ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .appointmentCreationUrl */ .h5 : _constants__WEBPACK_IMPORTED_MODULE_2__/* .leadCreationUrl */ .lA;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(url), payload);
            resolve(content);
        } catch (error) {
            resolve(error);
        }
    });
};
const registerUser = async (param)=>{
    let { number , anonymousId =null  } = param;
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const body = {
                login: number
            };
            if (anonymousId) {
                body["anonymous-id"] = anonymousId;
            }
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .createAccountUrl */ .id, "?stage=initial"), body);
            resolve(content);
        } catch (error) {
            var ref;
            resolve(error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data);
        }
    });
};
const getPlacementName = async (param)=>{
    let { qrCodeId ="" , placementId =""  } = param;
    return new Promise(async (resolve, reject)=>{
        try {
            _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] */ .Gb.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.apimSubscriptionKey);
            const { data: content  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance */ .Gb)({
                url: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .placementNameUrl */ .TQ, "?qrCodeId=").concat(qrCodeId, "&placementId=").concat(placementId, "&channel=india")
            });
            resolve(content);
        } catch (error) {
            resolve(error.response);
        }
    });
};
const cleverTapSubscribe = async (param)=>{
    let { payload  } = param;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .cleverTapSubscribeUrl */ .UF), payload);
            resolve(content);
        } catch (error) {
            resolve(error);
        }
    });
};
const getKECAppointments = async (param)=>{
    let { city  } = param;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .getKECAppointmentsUrl */ .j4, "?city=").concat(city));
            resolve(content);
        } catch (error) {
            console.log(error, "error");
            reject(error);
        }
    });
};


/***/ }),

/***/ 5136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H_": function() { return /* binding */ activateUserFactor; },
/* harmony export */   "pE": function() { return /* binding */ registerUserOKTA; },
/* harmony export */   "yW": function() { return /* binding */ updateUserOKTA; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11310);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34326);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73350);




const registerUserOKTA = async (param)=>{
    let { number , anonymousId =null  } = param;
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const body = {
                login: number
            };
            if (anonymousId) {
                body["anonymous-id"] = anonymousId;
            }
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .createAccountUrl */ .id, "?stage=initial"), body);
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const activateUserFactor = async (payload)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const body = payload;
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.apiBaseUrl, "/customer/factor/activate"), body);
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const updateUserOKTA = async (payload)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const body = {
                firstName: payload === null || payload === void 0 ? void 0 : payload.fname,
                lastName: payload === null || payload === void 0 ? void 0 : payload.lname,
                email: payload === null || payload === void 0 ? void 0 : payload.email,
                login: payload === null || payload === void 0 ? void 0 : payload.login,
                mobile: payload === null || payload === void 0 ? void 0 : payload.mobile,
                oktaId: payload === null || payload === void 0 ? void 0 : payload.id
            };
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .createAccountUrl */ .id, "?stage=update"), body);
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 45648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ validNumber; },
/* harmony export */   "Nt": function() { return /* binding */ validateNoOfBathroom_optional; },
/* harmony export */   "Uc": function() { return /* binding */ validateOptionalEmail; },
/* harmony export */   "WQ": function() { return /* binding */ validText; },
/* harmony export */   "cE": function() { return /* binding */ validPincode; },
/* harmony export */   "er": function() { return /* binding */ validPhone; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "v6": function() { return /* binding */ validateNoOfBathroom_mandatroy; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55111);

const validNumber = (text)=>{
    const validRegex = _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"] === null || _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"] === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_NUMBER;
    return validRegex.test(text);
};
const validPhone = (text)=>{
    const validRegex = _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"] === null || _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"] === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_PHONE_NUMBER;
    return validRegex.test(text);
};
const validText = (text)=>{
    const validRegex = _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"] === null || _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"] === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_USER_TEXT;
    return validRegex.test(text);
};
const validateEmail = (email)=>{
    if (_constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_EMAIL.test(email)) return true;
    return false;
};
const validateOptionalEmail = (email)=>{
    if (_constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_EMAIL_OPTIONAL.test(email)) return true;
    return false;
};
const validPincode = (pinCode)=>{
    return _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_PINCODE.test(pinCode) ? true : false;
};
const validateNoOfBathroom_optional = (item)=>{
    return _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_NO_OF_BATHROOM_OPTIONAL.test(item) ? true : false;
};
const validateNoOfBathroom_mandatroy = (item)=>{
    return _constants_index__WEBPACK_IMPORTED_MODULE_0__["default"].REGEX_NO_OF_BATHROOM_MANDATORY.test(item) ? true : false;
};



/***/ }),

/***/ 77529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Button_buttonWrapper__9Vvy_","load":"Button_load___Y_wM"};

/***/ }),

/***/ 21531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputFieldWrapper":"Input_inputFieldWrapper__nt6o0"};

/***/ }),

/***/ 43106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__asWMh"};

/***/ }),

/***/ 93468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__KI6CF","inlineCheckbox":"Checkbox_inlineCheckbox__4YHUm"};

/***/ })

}]);